var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"offline-indicator"},[_c('div',{staticClass:"icon"},[_c('font-awesome-icon',{attrs:{"icon":"times","size":"5x"}})],1),_vm._v("\n  No data known and currently offline\n")])}
var staticRenderFns = []

export { render, staticRenderFns }